export default {
footer: {
    ageRestriction: "Nuestra plataforma está dirigida únicamente a usuarios mayores de 18 años. El juego puede crear adicción. Por favor, juegue de forma responsable y solo como entretenimiento. Para más información, visite nuestra página de Juego Responsable.",
    followUs: "SÍGUENOS",
    company: "EMPRESA",
    legal: "LEGAL",
    support: "SOPORTE",
    gameProviders: "PROVEEDORES DE JUEGOS",
    copyright: "Copyright © 2019-2026 LOGO. Todos los derechos reservados.",
	documents: "Documentos",
  }
}
